import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { unitApi } from "../../../api/y-te/unitApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eUnitActionTypeIds,
	IUnitDeleteStart,
	IUnitLoadDetailStart,
	IUnitSaveStart
} from "../../action-types/y-te/IUnitActionTypes";
import { unitActions } from "../../actions/y-te/unitActions";

export function* unitSaga(): any {
	yield takeLatest(eUnitActionTypeIds.LOAD_START, loadUnitWorker)
	yield takeLatest(eUnitActionTypeIds.LOAD_DETAIL_START, loadUnitDetailWorker)
	yield takeEvery(eUnitActionTypeIds.SAVE_START, saveUnitWorker)
	yield takeEvery(eUnitActionTypeIds.DELETE_START, deleteUnitWorker)
}

function* loadUnitWorker(): any {
	const res: IBaseResponeModel = yield call([unitApi, unitApi.SelectAll])
	if (res.is_success) {
		yield put(unitActions.loadUnitSuccess(res.data || []))
	} else {
		yield put(unitActions.loadUnitError(res.message || "Không tải được danh sách đơn vị"))
	}
}

function* loadUnitDetailWorker(action: IUnitLoadDetailStart): any {
	const res: IBaseResponeModel = yield call([unitApi, unitApi.SelectById], action.payload)
	if (res.is_success) {
		if (res.data) {
			yield put(unitActions.loadUnitDetailSuccess(res.data))
		}
	} else {
		yield put(unitActions.loadUnitDetailError(res.message || "Không tải được chi tiết đơn vị"))
	}
}

function* saveUnitWorker(action: IUnitSaveStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([unitApi, unitApi.Update], action.payload);
	} else {
		res = yield call([unitApi, unitApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(unitActions.saveUnitSuccess(is_update))
	} else {
		yield put(unitActions.saveUnitError(res.message || "Không lưu được đơn vị"))
	}
}

function* deleteUnitWorker(action: IUnitDeleteStart): any {
	const res: IBaseResponeModel = yield call([unitApi, unitApi.Delete], action.payload)
	if (res.is_success) {
		yield put(unitActions.deleteUnitSuccess())
	} else {
		yield put(unitActions.deleteUnitError(res.message || "Không xoá được đơn vị"))
	}
}
